module.exports = __webpack_public_path__ + "static/img/info-ADVANTAGES-global-opps.b2abc84.png";


//////////////////
// WEBPACK FOOTER
// ./static/info-ADVANTAGES-global-opps.png
// module id = J1z8
// module chunks = 1